import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator';

export class AddRoleAccountDto {
  @IsUUID()
  @IsNotEmpty()
  accountId: string;

  @IsString()
  @IsNotEmpty({
    message: 'Вы забыли ввести название роли',
    groups: ['submit'],
  })
  roleName: string;

  @IsUUID()
  @IsOptional()
  parentRoleId?: string;
}
